import { 
    SASP_LEADREBOARD, SASP_LEADREBOARD_FAILED, 
    CME_CONFIRMATION_FAILED, DEREGISTER, DEREGISTER_FAILED, 
    GET_USER_DETAILS, GET_USER_DETAILS_FAILED, 
    LOGIN_USER_FAIL, LOGIN_USER_SUCCESS, 
    SEND_SUCCESS_LOGIN_FEEDBACK, LOGOUT_SUCCESS, 
    LOGOUT_FAILURE, UPDATE_PROFILE, UPDATE_PROFILE_FAIL, 
    SHARE_USERS, SHARE_USERS_FAILED, NOTIFICATIONS_FAILED,
    DAILY_USER, DAILY_USER_FAIL, GET_RESIDENCY_PROGRAM, 
    GET_RESIDENCY_PROGRAM_FAILED, GET_RESIDENT_DATA, GET_RESIDENT_DATA_FAILED,
    SASP_REPORT,
    SASP_CME_YEARS,
    GET_MESSAGES
} from "../actions";
import { setLocalStorage } from "../common";

//TODO add reducers for user_details and cme_confirmations

const INITIAL_STATE = {
    auth: false,
    errorMessage: "",
    errorCode: "",
    holdDevice: 1,
    auth_feedback: [],
    user_details: {
        cmeYears: 'No SASP Purchased',
        newMessages: 0
    },
    saspyears: null,
    appreporting: null,
    residencydata: null,
    residentprogram: null,
    cme_confirmations: [],
    leaderboard: [],
    accessList: [],
    dailyQuestion: {},
    isDaily: 0,
    program: null,
    resident: null,
    newMessages: 0,
    messages: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_MESSAGES: 
            return { ...state, messages: action.payload }
        case SASP_CME_YEARS: 
            return { ...state, saspyears: action.payload }
        case SASP_REPORT: 
            return { ...state, appreporting: action.payload }
        case GET_RESIDENT_DATA:
            return { ...state, resident: action.payload, residencydata: action.payload }
        case GET_RESIDENCY_PROGRAM:
            return { ...state, program: action.payload, residentprogram: action.payload }
        case LOGIN_USER_FAIL:
            return {
                ...state,
                auth: false,
                errorMessage: action.payload.errorMessage,
                errorCode: action.payload.errorCode
            };
        case LOGIN_USER_SUCCESS:
            return { ...state, auth: true, errorMessage: "", errorCode: "", holdDevice: 1 };
        case SEND_SUCCESS_LOGIN_FEEDBACK:
            return { ...state, auth_feedback: action.payload };
        case DEREGISTER: 
            return { ...state, holdDevice: 0 }
        case LOGOUT_SUCCESS:
            // return { ...state }    
            return { ...state, auth: false, errorMessage: "", errorCode: "", holdDevice: 1, auth_feedback: [], user_details: { cmeYears: 'No SASP Purchased' }, cme_confirmations: [], }
        case DEREGISTER_FAILED:
            return { ...state, errorMessage: action.payload };
        case GET_USER_DETAILS:
            const dt = Date.now()
            localStorage.setItem(`sasp_user_DT`, dt)
            return { ...state, user_details: action.payload, newMessages: action.payload.newMessages };
        case UPDATE_PROFILE: {
            return { ...state }
        }
        case SASP_LEADREBOARD: 
            return { ...state, leaderboard: action.payload}
        case SHARE_USERS:
            return { ...state, accessList: action.payload }
        case DAILY_USER:
            return { ...state, isDaily: action.payload.isDaily, dailyQuestion: action.payload.question };
            
        case DAILY_USER_FAIL:
        case GET_RESIDENCY_PROGRAM_FAILED:
        case GET_USER_DETAILS_FAILED:
        case CME_CONFIRMATION_FAILED:
        case LOGOUT_FAILURE: 
        case UPDATE_PROFILE_FAIL:
        case SASP_LEADREBOARD_FAILED:
        case SHARE_USERS_FAILED:
        case NOTIFICATIONS_FAILED:
        case GET_RESIDENT_DATA_FAILED: 
            return { ...state, error: action.payload }
        default:
            return state;
    }
};
